export const LIFECYCLE_STORAGE_KEYS = {
  PAUSE: 'lifecycle_pause',
};
